import { render, staticRenderFns } from "./MessageOverlay.vue?vue&type=template&id=4f75c9ce&lang=pug&"
import script from "./MessageOverlay.vue?vue&type=script&lang=ts&"
export * from "./MessageOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports